export default "__VITE_ASSET__Iv8nalIL__"